import React from 'react';
import { SEOHead } from './components/SEOHead';
import { StructuredData } from './components/StructuredData';
import { GoogleTag } from './components/GoogleTag';
import { StickyBar } from './components/StickyBar';
import { Hero } from './components/Hero';
import { BonusSection } from './components/BonusSection';
import { Testimonials } from './components/Testimonials';
import { ComparisonTable } from './components/ComparisonTable';
import { FAQ } from './components/FAQ';
import { Timeline } from './components/Timeline';
import { PackageCards } from './components/PackageCards';
import { FinalCTA } from './components/FinalCTA';
import { UsefulLinks } from './components/UsefulLinks';
import { Footer } from './components/Footer';
export function App() {
  return <div className="min-h-screen bg-white" data-id="element-0">
      <SEOHead data-id="element-1" />
      <StructuredData data-id="element-2" />
      <GoogleTag data-id="element-3" />
      <StickyBar data-id="element-4" />
      <main data-id="element-5">
        <Hero data-id="element-6" />
        <BonusSection data-id="element-7" />
        <Testimonials data-id="element-8" />
        <ComparisonTable data-id="element-9" />
        <FAQ data-id="element-10" />
        <Timeline data-id="element-11" />
        <PackageCards data-id="element-12" />
        <FinalCTA data-id="element-13" />
        <UsefulLinks data-id="element-14" />
      </main>
      <Footer data-id="element-15" />
    </div>;
}